// extracted by mini-css-extract-plugin
export var socialmediaicons = "SocialMediaIcons-module--socialmediaicons--330dd";